//基础信息
export default [
  {
    path: '/takeOutCate',
    component: resolve => require(['../pages/takeOut/takeOutCate.vue'], resolve),
    name: 'takeOutCate',
    title: "外卖分类",
    meta: {
      title: "外卖分类"
    }
  },
  {
    path: '/takeOutGoods',
    component: resolve => require(['../pages/takeOut/takeOutGoods.vue'], resolve),
    name: 'takeOutGoods',
    title: "外卖商品",
    meta: {
      title: "外卖商品"
    }
  },
  {
    path: '/takeOutOrder',
    component: resolve => require(['../pages/takeOut/takeOutOrder.vue'], resolve),
    name: 'takeOutOrder',
    title: "外卖订单",
    meta: {
      title: "外卖订单"
    }
  },
  {
    path: '/takeOutEvaluate',
    component: resolve => require(['../pages/takeOut/takeOutEvaluate.vue'], resolve),
    name: 'takeOutEvaluate',
    title: "外卖评价",
    meta: {
      title: "外卖评价"
    }
  },
  {
    path: '/takeOutAddress',
    component: resolve => require(['../pages/takeOut/takeOutAddress.vue'], resolve),
    name: 'takeOutAddress',
    title: "外卖地址",
    meta: {
      title: "外卖地址"
    }
  },
  {
    path: '/takeOutTime',
    component: resolve => require(['../pages/takeOut/takeOutTime.vue'], resolve),
    name: 'takeOutTime',
    title: "外卖配送时间",
    meta: {
      title: "外卖配送时间"
    }
  },
  {
    path: '/recoTakeOut',
    component: resolve => require(['../pages/takeOut/recoTakeOut.vue'], resolve),
    name: 'recoTakeOut',
    title: "外卖推荐",
    meta: {
      title: "外卖推荐"
    }
  },
  {
    path: '/takeOutSelfmention',
    component: resolve => require(['../pages/takeOut/takeOutSelfmention.vue'], resolve),
    name: 'takeOutSelfmention',
    title: "自提点设置",
    meta: {
      title: "自提点设置"
    }
  },
];
